/**
 * 获取iframeTab下的唯一值，iframeTab未删除时，唯一值不变，iframeTab删除后再打开，唯一值变化
 */
export const getIframeTabUid = (prefix: string) => {
  const iframe = window.frameElement;
  // 获取 iframe 的 id 属性
  const iframeId = iframe?.id;
  return `${prefix}_${iframeId}`;
};
